import { render, staticRenderFns } from "./PurchaseOrderReviewPrint.template.vue?vue&type=template&id=40bd71ce&scoped=true&"
var script = {}
import style0 from "./PurchaseOrderReviewPrint.template.vue?vue&type=style&index=0&id=40bd71ce&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bd71ce",
  null
  
)

export default component.exports